export interface AuthState {
  user?: AdminData
}

export enum AUTH_ACTIONS {
  LOAD_DATA = 'AUTH_LOAD_DATA'
}

export interface AuthCredentials {
  email: string
  password: string
}

export enum AuthRoles {
  Admin = 'admin',
  User = 'user'
}

export type AdminPrivileges = {
  manageBooks: boolean
  manageStandaloneExercises: boolean
  manageStudySets: boolean
  manageShelves: boolean
  manageMiniCourses: boolean
  manageSchoolUsers: boolean // access to tutors, teachers, student and schools
  manageSettings: boolean // access to cerftool, mobile app update list
}

export interface AdminData {
  _id: string
  email: string
  role: AuthRoles.Admin
  privileges: AdminPrivileges
}

export interface AuthLoadUser {
  type: AUTH_ACTIONS.LOAD_DATA
  user: AdminData
}

export type AuthActions = AuthLoadUser
